import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/complain-policy/hero";
import PP from "../components/complain-policy/content";
import CTA from "../components/universal/cta";
import Contact from "../components/universal/contact";
import Footer from "../components/universal/footer";

function Index() {
  return (
    <div>
      <Helmet>
        <title>
          Complaints Policy | Invisalign Ilkley - We're Here to Help
        </title>
        <meta
          name="description"
          content="Learn about our complaint policy at Invisalign Ilkley. We value your feedback and are committed to resolving any concerns quickly, fairly, and professionally."
        />
        <link
          rel="canonical"
          href="https://www.invisalign-ilkley.com/complain-policy"
        />
      </Helmet>
      <Navbar />
      <Header />
      <PP />
      <CTA />
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;
